const EXPLICIT_PROTOCOL = /^(https?|mailto|tel|ftp):/i;
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const RELATIVE = /^[/#?]/;
const TEMPLATE_VARIABLE = /^\$\{?[a-zA-Z_]/;

/**
 * Turns whatever the user typed into a usable href. Anything that already
 * carries a protocol, points inside the app, or starts with a template
 * placeholder is left alone; a bare e-mail becomes mailto:, everything else
 * gets https://.
 */
export const normalizeUrl = (raw) => {
  const url = (raw || '').trim();
  if (!url) return '';
  if (EXPLICIT_PROTOCOL.test(url)) return url;
  if (EMAIL.test(url)) return `mailto:${url}`;
  if (RELATIVE.test(url)) return url;
  if (TEMPLATE_VARIABLE.test(url)) return url;
  return `https://${url}`;
};

/**
 * Plain-text of the current selection, with variable chips rendered as their
 * $placeholder so the dialog shows what the user actually sees in the editor.
 */
export const selectionText = (editor) => {
  const { from, to, empty } = editor.state.selection;
  if (empty) return '';
  return editor.state.doc.textBetween(from, to, ' ', (leaf) =>
    leaf.type.name === 'variable' ? `$${leaf.attrs.id}` : '',
  );
};
